import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../api/client';
import Card from '../components/Card';
import { AvatarWithFallback } from '../components/Avatar';
import steamLogo from '../steam-logo.png';
import discordLogo from '../discord-logo.png';

function steamProfileUrl(steamId) {
  if (!steamId) return null;
  return /^\d+$/.test(steamId)
    ? `https://steamcommunity.com/profiles/${steamId}`
    : `https://steamcommunity.com/id/${steamId}`;
}

export default function PublicProfile() {
  const { id } = useParams();
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true); setError('');
    api.get(`/api/users/${id}/profile`)
      .then((r) => setProfile(r.data))
      .catch((err) => setError(err.response?.data?.detail || 'Profil nicht gefunden'))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return (
    <div className="flex justify-center py-16">
      <div className="animate-spin rounded-full h-8 w-8 border-2 border-ocean-400 border-t-transparent" />
    </div>
  );

  if (error || !profile) return (
    <div className="max-w-xl mx-auto">
      <div className="alert-error">{error || 'Profil nicht gefunden'}</div>
      <Link to="/" className="text-sm text-ocean-600 hover:underline mt-3 inline-block">← Zurück</Link>
    </div>
  );

  return (
    <div className="max-w-xl mx-auto">
      <h1 className="page-title">Spielerprofil</h1>
      <Card>
        <div className="flex items-center gap-5 flex-wrap">
          <AvatarWithFallback user={profile} size="xl" className="border-2 border-ocean-200 shadow" />
          <div className="flex-1 min-w-0">
            <p className="font-bold text-ocean-900 text-xl">{profile.firstname} {profile.lastname}</p>
            <p className="text-sm text-slate-500">@{profile.username}</p>
            {profile.nickname && <p className="text-xs text-slate-400 mt-0.5">Nickname: {profile.nickname}</p>}
            <div className="flex flex-wrap gap-x-3 gap-y-0.5 mt-1">
              {profile.discord_name && (
                <span className="text-xs text-slate-500 inline-flex items-center gap-1">
                  <img src={discordLogo} alt="Discord" className="w-3.5 h-3.5 object-contain" />
                  {profile.discord_name}
                </span>
              )}
              {profile.steam_id && (
                <a href={steamProfileUrl(profile.steam_id)} target="_blank" rel="noopener noreferrer"
                  className="text-xs text-slate-500 hover:text-ocean-600 hover:underline inline-flex items-center gap-1">
                  <img src={steamLogo} alt="Steam" className="w-3.5 h-3.5 object-contain" />
                  Steam-Profil
                </a>
              )}
            </div>
          </div>
        </div>
      </Card>

      {profile.seats && profile.seats.length > 0 && (
        <Card className="mt-4">
          <p className="section-title mb-3">Sitzplatz</p>
          <div className="space-y-2">
            {profile.seats.map((s) => (
              <div key={s.event_id} className="flex justify-between items-center text-sm border-b border-slate-50 pb-2 last:border-0 last:pb-0">
                <Link to={`/events/${s.event_id}`} className="text-ocean-700 hover:underline font-medium">{s.event_name}</Link>
                <span className="font-semibold text-slate-700">🪑 {s.seat_label}</span>
              </div>
            ))}
          </div>
        </Card>
      )}
    </div>
  );
}
